export const authRoles = {
  sa: ['SA'],
  admin: ['SA', 'ADMIN'],
  editor: ['SA', 'ADMIN', 'EDITOR'],
  guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'],
  merchant: ['MERCHANT', 'ADMIN', 'SUPPORT','DEV','RESELLER','ACCOUNTING'],
  support: ['ADMIN','SUPPORT','RESELLER'],
  reseller: ['ADMIN','RESELLER'],
  billing: ['ADMIN','ACCOUNTING'],
  developer:['ADMIN','DEV','SUPPORT','RESELLER'],
  invoicing: [],
  contacts: [],
  recurring: []
}
